import { GET_ALL_ACCA7_RESPONSE_SUCCESS } from "./actionTypes"
import { combineReducers } from "redux"

const Index = (state = [], action) => {
  const { payload } = action
  switch (action.type) {
    case GET_ALL_ACCA7_RESPONSE_SUCCESS:
      return payload
    default:
      return state
  }
}

const acca7 = combineReducers({
  Index,
})

export default acca7
